const availableLangs = [
  'az',
  'be',
  'bg',
  'bs',
  'da',
  'de',
  'dk',
  'el',
  'en',
  'es',
  'et',
  'fi',
  'fr',
  'hi',
  'hk',
  'hr',
  'hu',
  'it',
  'kk',
  'km',
  'lo',
  'lt',
  'lv',
  'ms',
  'my',
  'nb',
  'ne',
  'nl',
  'pl',
  'ru',
  'sr',
  'sv',
  'ug',
  'uk',
  'vi',
  'zh'
];

const marketLocalLang: { [market: string]: string } = {
  az: 'az',
  ba: 'bs',
  bg: 'bg',
  by: 'be',
  ch: 'de',
  cn: 'zh',
  cy: 'el',
  de: 'de',
  dk: 'da',
  ee: 'et',
  fi: 'fi',
  fr: 'fr',
  gb: 'en',
  gr: 'el',
  hk: 'zh',
  hr: 'hr',
  hu: 'hu',
  in: 'hi',
  it: 'it',
  kh: 'km',
  kz: 'kk',
  la: 'lo',
  lt: 'lt',
  lv: 'lv',
  me: 'bs',
  mm: 'my',
  my: 'ms',
  nl: 'nl',
  no: 'nb',
  np: 'ne',
  pl: 'pl',
  rs: 'sr',
  se: 'sv',
  sg: 'en',
  ua: 'uk'
};

const defaultLang = 'en';

export { availableLangs, defaultLang, marketLocalLang };
